import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from 'src/app/guards/auth.guard';
import { PolicyDetailComponent } from './pages/policy-detail/policy-detail.component';

const routes: Routes = [
    {
        path: ':id',
        component: PolicyDetailComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'ath/operations',
                loadChildren: () => import('src/app/modules/athora/athora.module').then(m => m.AthoraModule)
            },
            {
                path: 'isv/operations',
                loadChildren: () => import('src/app/modules/isv/isv.module').then(m => m.IsvModule)
            }
        ]
    }
]

@NgModule({
    imports: [RouterModule.forChild((routes))],
    exports: [RouterModule]
})
export class PolicyRoutingModule {
}
